import { OrderSummaryInterface } from "@/interface/order.inteface";
import { OrderSummaryMetaType, OrderSummaryType } from "@/types/orders";
import { OrderSummary } from "./";
import { OrdersMeta } from "@/modules/orders/meta";
import { OrdersInterface } from "@/interface/business/order.interface";

export default class Orders implements OrdersInterface {
  static MODULE_NAME = "orders/managements";

  list: Array<OrderSummaryInterface> = [];
  count: number = 0;
  meta: OrderSummaryMetaType;
  key: number = 1;

  constructor(orders: Array<OrderSummaryType>, count: number = 0, meta: OrderSummaryMetaType) {
    orders.map((order: OrderSummaryType) => this.list.push(new OrderSummary(order)));
    this.count = count;
    this.meta = new OrdersMeta(meta);
  }

  getOtherOrdersCount() {
    return (
      this.meta.count_status.DRAFT +
      this.meta.count_status.PENDING +
      this.meta.count_status.OPENED +
      this.meta.count_status.CANCELED +
      this.meta.count_status.REJECTED
    );
  }
}
